<style lang="scss" scoped>
@use "@/assets/scss/v2/colors";
@use "@/assets/scss/v2/typography";

.the-case {
  @include typography.main-text;
  position: absolute;
  top: 22px;
  left: -10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: colors.$button-secondary-grey-hover;
  color: colors.$text-primary-dark;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    bottom: -10px;
    width: 0;
    height: 0;
    border-bottom: 9px solid transparent;
    border-right: 9px solid colors.$text-primary-grey;
  }
}

.the-case__black {
  background-color: colors.$background-primary-dark;
}
</style>

<template>
  <div
    class="demo__BubbleBlock always demo__pointer"
    v-bind:class="{
      ['demo__height--' + height]: !!height,
      'demo__BubbleBlock--col-v2': !marginType,
      'demo__BubbleBlock--col': marginType === 'base',
      ['skeleton-' + bg]: demo,
      ['demo__border--' + border]: border ? true : false,
      ['demo__bg--' +
      (isMobile && bg === 'bgPlateDark' ? 'plateMobile' : bg)]: true,
      ['demo__color--' + color]: true,
    }"
    @click="clickPath ? $router.push(clickPath) : false"
  >
    <div
      class="demo__flex demo__flex-column demo__height-full 111"
      v-bind:class="{
        ['demo__BubbleBlock_padding--v' + padding]: true,
      }"
      v-if="object.id"
    >
      <div
        class="demo__flex demo__flex-space-around demo__relative the-case__black"
        v-if="!noImage"
      >
        <img
          :src="bgImage || '/404Serie.png'"
          @error="
            (e) => {
              e.target.src = '/404Serie.png';
            }
          "
        />
      </div>
      <StatusBadge v-if="status" :status="status" position="right-top" />

      <template v-if="!isSlot">
        <div
          class="demo__margin-top--10 demo__font--14 demo__weight--600 demo__font-mobile--16 demo__LikeAndCommentBlock--title"
        >
          {{ title || object.title }}
        </div>
        <div
          class="demo__margin-top--10 demo__font--14 demo__font-mobile--14 demo__weight--400 demo__LikeAndCommentBlock--desc"
        >
          <MobiledocText
            v-if="desc.mobiledoc"
            :mobiledoc="object[desc.field]"
            :just-string="true"
          />
          <div v-else>
            {{ desc.value || object[desc.field] }}
          </div>
        </div>
        <div
          class="demo__flex demo__flex-bottom demo__font--13 demo__weight--600 demo__color--bgDescription"
        >
          <div
            v-if="badges && badges.length > 0"
            class="demo__flex demo__flex-row demo__gap--5 demo__flex-wrap"
          >
            <div
              v-for="badge in badges"
              :key="badge"
              class="demo__margin-top--5 demo__flex demo__flex-middle demo__radius--4 demo__height--21 demo__bg--bgSecondary demo__padding--6"
            >
              {{ badge }}
            </div>
          </div>
        </div>

        <div @click.stop>
          <BlockBottomReactions
            class="demo__margin-top--10"
            mode="horizontal"
            :object="object"
            :author="{
              ...object.author,
              initials: true,
              company: null,
            }"
            :reactions="reactions"
            :css="{
              author: {
                font: {
                  size: 12,
                  weight: 600,
                },
              },
              reactions: {
                margin: 16,
                icon: {
                  size: 14,
                  margin: 6,
                },
                text: {
                  size: 14,
                  weight: 600,
                },
              },
            }"
          />
        </div>

        <div v-if="isCase" class="the-case">
          {{ $t("Case v2") }}
        </div>
      </template>
      <template v-else>
        <slot></slot>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import MobiledocText from "Components/MobiledocText/Viewer";
import BlockBottomReactions from "Components/BlockBottomReactions";
import StatusBadge from "Components/StatusBadge";
export default {
  components: {
    MobiledocText,
    BlockBottomReactions,
    StatusBadge,
  },
  props: {
    object: {
      required: true,
      type: Object,
    },
    demo: {
      required: false,
      default: false,
    },
    bg: {
      required: true,
      type: String,
    },
    color: {
      required: true,
      type: String,
    },
    border: {
      required: false,
      type: String,
      default: undefined,
    },
    desc: {
      required: false,
      default: undefined,
    },
    clickPath: {
      required: false,
      type: String,
      default: undefined,
    },
    title: {
      required: false,
      type: String,
    },
    status: {
      required: false,
      default: undefined,
    },
    marginType: {
      required: false,
      type: String,
      default: undefined,
    },
    noImage: {
      required: false,
      type: Boolean,
      default: false,
    },
    isSlot: {
      required: false,
      type: Boolean,
      default: false,
    },
    height: {
      required: false,
      type: [Number, String],
      default: 0,
    },
    padding: {
      required: false,
      type: Number,
      default: 2,
    },
    badges: {
      required: false,
      type: Array,
      default: undefined,
    },
    isCase: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLike: false,
      likeAnimate: false,
    };
  },
  computed: {
    ...mapGetters(["isMobile", "api"]),
    bgImage() {
      if (this.noImage) {
        return null;
      }

      if (this.object?.preview_url) {
        return this.object.preview_url;
      }

      return this.object &&
        this.object.preview_image_urls &&
        this.object.preview_image_urls.length
        ? this.object.preview_image_urls[0]
        : null;
    },
    reactions() {
      return [
        {
          id: "like",
          field: "likes_count",
          icon: (this.object || {}).user_is_liked
            ? "fa-solid fa-heart demo__color--brandPrimary"
            : "fa-light fa-heart demo__color--white",
          click: this.addLike,
          animate: this.likeAnimate,
          authRequired: true,
        },
        {
          field: "comments_count",
          icon: "fa-light fa-comment",
        },
      ];
    },
  },
  mounted() {
    this.$accessModule("object_block", this);
  },
  methods: {
    addLike() {
      this.api
        .sendLike({
          data: {
            content_type_key: this.object.content_type_key,
            id: this.object.id,
          },
        })
        .then((response) => {
          this.likeAnimate = true;
          this.object.user_is_liked = response.data.liked;
          this.object.likes_count += response.data.liked ? 1 : -1;
          setTimeout(() => {
            this.likeAnimate = false;
          }, 300);
        });
    },
  },
};
</script>
